var _defs, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuickMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    viewBox: "0 0 117 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".message_a,.message_b,.message_c{fill:#fff;}.message_a{opacity:0.3;}.message_b{font-size:12px;font-family:Montserrat-Bold, Montserrat;font-weight:700;opacity:0.301;}.message_c{opacity:0.297;}svg:hover .message_b,svg:hover .message_c{opacity:1;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "message_a",
    d: "M10,0h97a10,10,0,0,1,10,10V39a10,10,0,0,1-10,10H10A10,10,0,0,1,0,39V10A10,10,0,0,1,10,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.857)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "message_b",
    transform: "translate(46 22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "QUICK"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "MESSAGE")), /*#__PURE__*/React.createElement("path", {
    className: "message_c",
    d: "M12.321,6C5.527,6,0,10.145,0,15.241c0,3.365,2.333,6.352,6.161,7.99v2.792A1.539,1.539,0,0,0,8.4,27.394l6.038-3.076c5.93-.761,10.205-4.545,10.205-9.077C24.643,10.145,19.115,6,12.321,6Zm1.491,15.29a1.554,1.554,0,0,0-.529.159L9.241,23.509V22.172A1.54,1.54,0,0,0,8.2,20.714c-3.109-1.06-5.117-3.208-5.117-5.473,0-3.339,4.232-6.161,9.241-6.161s9.241,2.822,9.241,6.161C21.563,18.2,18.231,20.8,13.812,21.29Z",
    transform: "translate(12.857 7.438)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickMessage);
export default __webpack_public_path__ + "static/media/quick-message.24e4afa2.svg";
export { ForwardRef as ReactComponent };